import React from 'react';
import { ErrorIcon } from '@qualtrics/ui-react/icons';
import styles from '../../command-palette.scss';

export const CommandPaletteError = () => {
  return (
    <div className={styles.commandPaletteError} role="alert">
      <ErrorIcon aria-hidden="true" size="small" />
      <div className={styles.errorText}>
        An error occured while loading the command palette. Please try again
        later.
      </div>
    </div>
  );
};
